import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import ViewTable from './ViewTable';
import { fetchAppointmentView } from 'slices/appointmentSlice';
import { useDispatch, useSelector } from 'react-redux';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import toast from 'react-hot-toast';
import { setActionAssign } from 'slices/actionButtonSlice';
import { fetchAppointmentLogs } from 'slices/appointmentSlice';
import LogsTable from './LogsTable';
import { setAddAppointmentPopup } from 'slices/appointmentSlice';
import { appointmentsSelector } from 'slices/appointmentSlice';
import { closeAppointmentPopup } from 'slices/appointmentSlice';
import { removeAppointment } from 'slices/appointmentSlice';
import Swal from 'sweetalert2';
import FullPageLoader from 'components/common/FullPageLoader';
import { usePermissions } from 'layouts/Admin';


const AppointmentView = () => {

    const { id } = useParams();
    const navigate = useNavigate();
    const { checkPermission } = usePermissions()
    const dispatch = useDispatch();
    const [item, setItem] = React.useState({});
    const [loading, setLoading] = React.useState(false)
    const [logs, setLogs] = React.useState([]);
    const [cancelModal, setCancelModal] = React.useState(false);
    const [donotCover, setDonotCover] = React.useState(false);
    const [addPatient, setAddPatient] = React.useState(false);
    const [couldNotCover, setCouldNotCover] = React.useState(false);

    const [assignInterpreter, setAssignInterpreter] = React.useState(false);
    const [rescheduleModal, setRescheduleModal] = React.useState(false);
    const [checkinCheckoutModal, setCheckinCheckoutModal] = React.useState(false);

    const { popup: appointmentPopUpState } = useSelector(appointmentsSelector);


    const callViewApi = async () => {
        const callBack = (success, message, data) => {
            setLoading(false);
            if (success) {
                setItem(data)
                // console.log(data)
            }
            else {
                console.log(message)
            }
            // setItem()
        }

        dispatch(fetchAppointmentView(id, callBack))
    };

    const fetchLogs = async () => {
        const callBack = (success, message, data) => {
            if (success) {
                setLogs(data)
                // console.log(data)
            }
            else {
                console.log(message)
            }
            // setLogs()
        }
        dispatch(fetchAppointmentLogs(id, callBack))
    }

    React.useEffect(() => {
        setLoading(true)
        callViewApi();
        fetchLogs();

    }, [id]);

    const handleCancel = () => {
        setCancelModal(true);
    };
    const handleCloseCancel = () => {
        setCancelModal(false);
    };
    const handleDonotCover = () => {
        setDonotCover(true);
    };
    const handleCloseDonotCover = () => {
        setDonotCover(false);
    };
    
    const handleAddPatient = () => {
        setAddPatient(true);
    };
    const handleCloseAddPatient = () => {
        setAddPatient(false);
    };

    const handleCouldNotCover = () => {
        setCouldNotCover(true);
    };
    const handleCloseCouldNotCover = () => {
        setCouldNotCover(false);
    };
    const handleReschedule = () => {
        setRescheduleModal(true);
    };
    const handleCloseReschedule = () => {
        setRescheduleModal(false);
    };
    const handleAssignInterpreter = () => {
        setAssignInterpreter(true);
    };
    const handleCloseAssignInterpreter = () => {
        setAssignInterpreter(false);
    };
    const handleOpenCheckinCheckoutModal = () => {
        setCheckinCheckoutModal(true);
    };
    const handleCloseCheckinCheckoutModal = () => {
        setCheckinCheckoutModal(false);
    };
    const handleEditAppointmentPopUp = () => {
        dispatch(
            setAddAppointmentPopup({
                show: true,
                item,
            })
        )
    };
    const handleCloseEditApptPopup = () => {
        dispatch(closeAppointmentPopup())
    }

    const handleSubmit = (data, end_point, callBack) => {

        const submitCallback = (success, message) => {
            callBack && callBack()
            if (success) {
                handleCloseCancel();
                handleCloseDonotCover();
                handleCloseCouldNotCover();
                handleCloseReschedule();
                handleCloseAssignInterpreter();
                handleCloseEditApptPopup()
                handleCloseCheckinCheckoutModal()
                handleCloseAddPatient();
                callViewApi();
                fetchLogs()
                toast.success(message, {
                    className: "successToast",
                });
                // scheduleDetailModal?.show && openModal()
            }
            else {
                toast.error(message,
                    {
                        className: "errorToast",
                    }
                );
            }
        }
        dispatch(
            setActionAssign(
                id,
                data,
                end_point,
                submitCallback
            )
        )
    }

    const editFormSubmitCallback = () => {
        callViewApi()
    }

    const handleRemove = () => {
        const callBack = (success, message) => {
            if (success) {
                new Swal({
                    title: message,
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                })

                navigate('/', { replace: true });



            }
            else {

                new Swal({
                    title: message,
                    icon: 'error',
                    timer: 2000,
                    showConfirmButton: false
                })


            }
        }
        new Swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
        })
            .then((result) => {
                if (result.isConfirmed) {
                    dispatch(
                        removeAppointment(
                            id,
                            callBack
                        )
                    )
                }
            })




    }

    const navigateToInviteInterpreter = () => {
        // window.location.href = `/invite-interpreter/${id}`;
        navigate(`/appointments/invite-interpreter/${id}`);
    }



    return (
        <div className="content" style={{}}>
            {loading && <FullPageLoader />}
            <div className="card_table view_table_custom">

                <div className="row_main_head">
                    <h2 className={`main_heading`}>View Appointment </h2>
                    <div className='mb-3'>
                        <div className='text-transform-capitalize main_heading' >
                            Status : {item?.status}
                        </div>
                        
                        {(item?.type == 'OPI On Demand') &&
                        <SubmitButton 
                            buttonType="button" 
                            btnText="Add Patient"
                            handleSubmit={handleAddPatient} 
                        />}
                    </div>

                </div>

                <div className='row-primary flex-wrap'>
                    {checkPermission('Copy Appointment') &&
                        <SubmitButton buttonType="button" className={'lightPurple'}
                            btnText="Copy"
                            data-bs-toggle="modal"
                            data-bs-target="#copyAppointmentPopUp"
                        />
                    }
                    {(checkPermission('Assign Appointment') && item?.status !== "assigned") &&
                        <SubmitButton buttonType="button" className={'green'} btnText="Assign" handleSubmit={handleAssignInterpreter} />
                    }
                    {checkPermission('Edit Appointments') &&
                        <SubmitButton buttonType="button" className={'lightGrey'}
                            btnText="Edit"
                            data-bs-toggle="modal"
                            data-bs-target="#editAppointmentPopUp" handleSubmit={handleEditAppointmentPopUp}
                        />
                    }
                    {checkPermission('Reschedule Appointment') &&
                        <SubmitButton buttonType="button" className={'lightBlue'} btnText="Reschedule" handleSubmit={handleReschedule} />
                    }
                    {(checkPermission('Donot Cover') && item?.status !== "DNC") && <SubmitButton buttonType="button" btnText="Donot Cover" className="yellow" handleSubmit={handleDonotCover} />}
                    {(checkPermission('Could Not Cover') && item?.status !== "CNC") && <SubmitButton buttonType="button" btnText="Could not Cover" className="yellow" handleSubmit={handleCouldNotCover} />}
                    {(checkPermission('Cancel Appointment') && item?.status !== "cancelled") && <SubmitButton buttonType="button" className={'tomatoRed'} btnText="Cancel" handleSubmit={handleCancel} />}
                    {(checkPermission('Check-in/Check-out')) &&
                        <SubmitButton buttonType="button" className="Cancle_button"
                            btnText="Checkin / checkout"
                            data-bs-toggle="modal"
                            data-bs-target="#checkinCheckoutAdjustmentModal" handleSubmit={handleOpenCheckinCheckoutModal} />
                    }
                </div>
                <div className="row_table_head">
                    <div className="result-foot">
                        <span>Appointment ID : {item?.appid}</span> {/* Appointment ID */}
                    </div>
                </div>
                <ViewTable item={item} />
                {checkPermission('Invite Interpreter') &&
                    <SubmitButton buttonType="button" className={'green ms-3'} btnText="Invite Interpreters" handleSubmit={navigateToInviteInterpreter} />
                }
                <div className="Table_data_show overflow-auto">
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td className='col-6'>Check In Time:</td>
                                <td className='col-6'>{item?.appointment_assign?.checkin_time}</td>
                            </tr>
                            <tr>
                                <td className='col-6'>Check Out Time:</td>
                                <td className='col-6'>{item?.appointment_assign?.checkout_time}</td>
                            </tr>
                            <tr>
                                <td className='col-6'>Notes:</td>
                                <td className='col-6'>{item?.appointment_assign?.notes}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                {checkPermission('Delete Appointments') &&
                    <SubmitButton buttonType="button" className={'tomatoRed ms-3'} btnText="Remove this Appointment" handleSubmit={handleRemove} />
                }
            </div>


            <div className="card_table p-4">
                <div className="row_main_head mb-3">
                    <h2 className={`main_heading`}>Appointment Logs</h2>
                </div>
                <LogsTable logs={logs} />
            </div>

            {/* <SelectInterpreterModal
                isOpen={assignInterpreter}
                onClose={handleCloseAssignInterpreter}
                onConfirm={handleSubmit}
                appointmentId={id}

            />

            <CopyAppointment
                item={appointmentPopUpState.item}
                show={appointmentPopUpState.show}
                onClose={handleCloseEditApptPopup}
                callback={editFormSubmitCallback}
            />

            <EditAppointment
                item={appointmentPopUpState.item}
                show={appointmentPopUpState.show}
                onClose={handleCloseEditApptPopup}
                callback={editFormSubmitCallback}
            />

            <CancelModal
                isOpen={cancelModal}
                onClose={handleCloseCancel}
                onConfirm={handleSubmit}
                appointmentId={id}
            />
            <DonotCover
                isOpen={donotCover}
                onClose={handleCloseDonotCover}
                onConfirm={handleSubmit}
                appointmentId={id}
            />
            <AddPatient
                isOpen={addPatient}
                onClose={handleCloseAddPatient}
                onConfirm={handleSubmit}
                appointmentId={id}
                item={item}
            />
            <CouldNotCover
                isOpen={couldNotCover}
                onClose={handleCloseCouldNotCover}
                onConfirm={handleSubmit}
                appointmentId={id}
            />

            <RescheduleModal
                isOpen={rescheduleModal}
                onClose={handleCloseReschedule}
                onConfirm={handleSubmit}
                appointmentId={id}
            />

            <CheckinCheckoutAdjustmentModal
                isOpen={checkinCheckoutModal}
                handleClose={handleCloseCheckinCheckoutModal}
                onConfirm={handleSubmit}
                appointmentId={id}
                onSubmit={handleSubmit}
                item={item}
            /> */}


        </div>
    )
}





export default AppointmentView